module.exports = __webpack_public_path__ + "static/backgroundSolutions-491feb343f234e7a2a7e6da2c3aaeff7.png";